(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-grid-editorial"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var filterBtns = document.querySelectorAll('.sbm-filter-btn');
  var bento = document.getElementById('sbm-bento');
  var articlesWrap = document.getElementById('sbm-articles-wrap');

  if (!filterBtns.length || !articlesWrap) return;

  function filterArticles(activeFilter) {
    var allCards = articlesWrap.querySelectorAll('[data-tags]');
    allCards.forEach(function (card) {
      if (activeFilter === 'tutto') {
        card.classList.remove('sbm-card--hidden', 'sbm-featured--hidden');
      } else {
        var tags = card.dataset.tags || '';
        if (tags.indexOf(activeFilter) === -1) {
          card.classList.add(card.classList.contains('sbm-featured') ? 'sbm-featured--hidden' : 'sbm-card--hidden');
        } else {
          card.classList.remove('sbm-card--hidden', 'sbm-featured--hidden');
        }
      }
    });

    filterBtns.forEach(function (btn) {
      var isActive = btn.dataset.filter === activeFilter;
      btn.classList.toggle('sbm-filter-btn--active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filterArticles(btn.dataset.filter || 'tutto');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* Progress bar */
  var progressBar = document.getElementById('s-article-progress-bar');
  if (progressBar) {
    function updateProgress() {
      var scrollTop = window.scrollY;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var pct = docHeight > 0 ? Math.min(100, (scrollTop / docHeight) * 100) : 0;
      progressBar.style.width = pct + '%';
    }
    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  }

  /* Reveal on scroll via IntersectionObserver */
  var revealTargets = document.querySelectorAll(
    '.s-article-cta, .s-article-author, .s-article-related-grid, .s-article-related-products, .s-article-faq, .s-article-sources, .s-article-disclaimer, .s-article-share'
  );
  if ('IntersectionObserver' in window && revealTargets.length) {
    revealTargets.forEach(function (el) {
      el.classList.add('s-reveal');
    });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealTargets.forEach(function (el) { observer.observe(el); });
  }

  /* Drop cap: attiva classe se metafield lo richiede */
  var articleBody = document.getElementById('s-article-body');
  if (articleBody && articleBody.dataset.dropcap === 'true') {
    articleBody.classList.add('has-drop-cap');
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
